import { Injectable } from '@angular/core';
import { botSocket, spotSocket, userSocket, GridSocket, adminBotSocket, adminBotDownSideSocket, adminBotUpsideHanumanSocket, GuruBotSocket, HanumanBotSocket, OptionTradeSocket } from '../app.module';
import { CookieService } from 'ngx-cookie-service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  constructor(
    private userSocket: userSocket,
    private spotSocket: spotSocket,
    private botSocket: botSocket,
    private gridSocket: GridSocket,
    private AdminBotSocket: adminBotSocket,
    private AdminBotDownSideSocket: adminBotDownSideSocket,
    private adminBotUpsideHanumanSocket: adminBotUpsideHanumanSocket,
    private guruBotSocket: GuruBotSocket,
    private hanumanBotSocket: HanumanBotSocket,
    private optionTradeSocket: OptionTradeSocket,
    private cookieService: CookieService,
    private jwtHelperService: JwtHelperService
  ) { }

  ngOnInit() {
  }

  createSocketUser(userId: string) {
    this.userSocket.emit('CREATEROOM', userId)
    this.spotSocket.emit('CREATEROOM', userId)
    this.botSocket.emit('CREATEROOM', userId)
    this.gridSocket.emit('CREATEROOM', userId)
    this.AdminBotSocket.emit('CREATEROOM', userId)
    this.AdminBotDownSideSocket.emit('CREATEROOM', userId)
    this.adminBotUpsideHanumanSocket.emit('CREATEROOM', userId)
    this.guruBotSocket.emit('CREATEROOM', userId)
    this.hanumanBotSocket.emit('CREATEROOM', userId)
    this.optionTradeSocket.emit('CREATEROOM', userId)
  }

  emit(event: string, message: string) {
    this.spotSocket.emit(event, message);
    this.botSocket.emit(event, message);
  }

}
